import { render, staticRenderFns } from "./icon-issue.vue?vue&type=template&id=78f2789c&scoped=true&"
import script from "./icon-issue.vue?vue&type=script&lang=js&"
export * from "./icon-issue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f2789c",
  null
  
)

export default component.exports